module.exports = __webpack_public_path__ + "img/serve6.f4718d48.png";